export const aboutPage = {
  eyebrow: 'About Autoglow',
  title: 'Meet Lyle Patterson',
  titleHighlight: '',
  intro:
    'Autoglow is a dedicated GYEON ceramic coating studio in Drysdale, serving the Bellarine Peninsula and Geelong.',
  paragraphs: [
    'Lyle Patterson has more than 18 years of industry experience and leads Autoglow as a GYEON certified installer. The studio specialises in ceramic protection and paint correction, with tailored detailing recommended when the vehicle needs it.',
    'Every vehicle is inspected and prepared in the Drysdale studio before coating or correction, so the finish is matched to the paint in front of him — not a generic package.',
  ],
  quote: 'We don’t just wash cars; we curate finishes that stand the test of time and terrain.',
  stats: [
    ['EXPERIENCE', '18+ YEARS'],
    ['STATUS', 'GYEON CERTIFIED'],
    ['LOCATION', 'DRYSDALE, VIC'],
  ] as const,
}
